<section class="about-area py-5" style="background-color: #f9f9f9;">
  <div class="container-fluid">
    <div class="row">
      <!-- Budget Insights Section -->
      <div class="col-lg-6 col-xs-12 ">
        <div class="section-title mt-2">
          <h2>Budget Insights</h2>
          <div class="bar"></div>
        </div>
        <div class="about-content mb-4">
          <p>
            <strong>Budget Insights</strong> is a custom web-based application designed to assist management to monitor the implementation of their operating income and expenditure budgets.
            Budget variance analysis is the tool used inside Budget Insights to monitor how budgets are being implemented.
            Large variances, both positive and negative, are an indicator that budgets are not being properly implemented and corrective action needs to be taken.
          </p>
          <p>
            <strong>Budget Insights</strong> also includes a <strong>What-If analysis</strong> and <strong>scenario planning</strong> feature which allows for
            the mid-year forecasting of the <strong>income</strong> and <strong>expenditure budgets</strong>.
            Budget stress testing can also be carried out by using the What-If analysis feature to identify best-case and/or worst-case scenarios.

            Financial reporting, including ratio analysis, can be streamlined to improve mid-year reporting.
            The reporting also includes detailed variance analysis and year-on-year growth analysis for all income and expenditure items.
          </p>
          <p>
            The budget review process can also be significantly improved by implementing
            Budget Insights since the budget files from the application can be exported into a format that can be uploaded into any database or warehouse.
          </p>
        </div>
        <div>
          <iframe height="400px" class="w-100" style="border: 1px solid #ccc; border-radius: 10px;"
            src="https://app.powerbi.com/view?r=eyJrIjoiZGVkYTU3MDQtNTEzYi00NDA0LWEzYzMtZWUxMzM3YjBmNmQwIiwidCI6IjRlMmZkZDA3LWVhNGUtNDYyNy1hZWYzLTVmZTJhM2MxMTEzOSJ9&pageName=ReportSection5a87980a05938b6954d4"
            allowfullscreen>
          </iframe>
        </div>
      </div>

    <!-- HIMCO Section -->
<div class="col-lg-6 col-md-12  d-flex flex-column justify-content-center">
  <div class="section-title mt-2">
    <h2>HIMCO</h2>
    <div class="bar"></div>
  </div>
  <div class="about-content">

    <p><strong>HIMCO</strong> is a robust, web-based incident management platform designed to streamline
        and oversee the complete claims lifecycle between insurance companies and their network of service providers.
        The system facilitates seamless communication and operational efficiency—from the moment a client initiates
        a claim to the final resolution by the assigned service provider.</p>

    <p>Claims can be logged into the HIMCO system through three primary channels:</p>
    <ul>
      <li>Direct phone call from a key client to a HIMCO representative</li>
      <li>Submission via email</li>
      <li>Direct entry by a HIMCO agent or an authorized client using the Incident Management System (IMS)</li>
    </ul>

   </div><br><br><br><br>

    <div>
    <img src="assets/img/himco.png" alt="Davha Incubation" class="img-fluid rounded shadow-sm"
         style="max-width: 100%; height: auto;">
  </div>

</div>

    </div>
  </div>
</section>
